function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, inputText, inputWidth, isInputFocused, tags) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-tag-input-container--white-bg': isInputFocused
        }, {
          'mp-tag-input-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        const hasNoTags = !tags.size;
        const showSearchIcon = hasNoTags && $attr(`show-search-icon`);
        __jade_nodes = __jade_nodes.concat((showSearchIcon) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-tag-input-mp-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: 'search'
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-tag-input-top-input-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: $helpers.focusInput
            },
            "class": {
              'mp-tag-input-input-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (Array.from(tags));
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, tag, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                      "attrs": __vjadeStringifyAttrsIfObj(Object.assign({
                          'removable': $helpers.canRemoveTag(tag),
                          'size': 'small',
                          'tag-name': tag.label,
                          'theme': isInputFocused ? `light` : `secondary`,
                        },
                        tag.attrs
                      )),
                      "key": `tag-${tag}`,
                      "on": {
                        remove: $helpers.canRemoveTag(tag) && $helpers.removeTag(tag)
                      },
                    }));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var tag = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tag", {
                          "attrs": __vjadeStringifyAttrsIfObj(Object.assign({
                              'removable': $helpers.canRemoveTag(tag),
                              'size': 'small',
                              'tag-name': tag.label,
                              'theme': isInputFocused ? `light` : `secondary`,
                            },
                            tag.attrs
                          )),
                          "key": `tag-${tag}`,
                          "on": {
                            remove: $helpers.canRemoveTag(tag) && $helpers.removeTag(tag)
                          },
                        }));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());
            __jade_nodes = __jade_nodes.concat(h("input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                placeholder: $helpers.getPlaceholder(),
                disabled: $attr(`disable-input`),
                elref: `mpTagInputSearchInput`,
              }),
              "props": {
                type: 'text',
                value: inputText
              },
              "on": {
                input: $helpers.setInputText,
                keydown: $helpers.handleKeyDown,
                focus: $helpers.onFocusChange,
                blur: $helpers.onFocusChange,
              },
              "style": {
                width: hasNoTags ? '100%' : inputWidth
              },
              "class": Object.assign({}, {
                'mp-tag-input-empty': hasNoTags
              }, {
                'mp-tag-input-search-input': true
              }),
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": Object.assign({}, {
                'mp-tag-input-error': $attr(`error`)
              }, {
                'mp-tag-input-border': true
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(($attr(`mp-select-attrs`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.processMpSelectAttrs()),
            "on": {
              change: $helpers.onSelectChange,
              menuChange: $helpers.onSelectMenuChange,
            },
            "class": {
              'mp-tag-input-mp-select': true
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "inputText" in locals ? locals.inputText : typeof inputText !== "undefined" ? inputText : undefined, "inputWidth" in locals ? locals.inputWidth : typeof inputWidth !== "undefined" ? inputWidth : undefined, "isInputFocused" in locals ? locals.isInputFocused : typeof isInputFocused !== "undefined" ? isInputFocused : undefined, "tags" in locals ? locals.tags : typeof tags !== "undefined" ? tags : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;